import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';

import { fetchCustomTranslations } from '~/data/customTranslations';
import { useAuthentication } from '~/data/user/useAuthentication';
import { LibraryComponentProviders } from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { CustomTranslationList } from '~/scenes/AdminModule/components/People/components/ValueLists/CustomTranslations';
import { AppDispatch } from '~/store';

export const WrappedCustomTranslationsValueList = () => {
  const dispatch: AppDispatch = useDispatch();
  const { isAuthenticated } = useAuthentication();

  //TODO: LIBRARY WRAPPER FOR EVERY REDUX STORE
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchCustomTranslations());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <LibraryComponentProviders>
      <CustomTranslationList />
    </LibraryComponentProviders>
  );
};

export const CustomTranslationsValueList = () => (
  <Providers>
    <WrappedCustomTranslationsValueList />
  </Providers>
);

export const renderCustomTranslationsValueList = (containerId: string) => {
  ReactDOM.render(
    <Providers>
      <WrappedCustomTranslationsValueList />
    </Providers>,
    document.getElementById(containerId),
  );
};
